export EditProductCategoryModal from './productCategoryModal/EditProductCategoryModal';
export PricesEditor from './PricesEditor';



// WEBPACK FOOTER //
// ./scripts/components/restaurantMenu/index.js